import React, { useState } from 'react';
import GroupClaimPage from './GroupClaimPage';

const GroupClaimDemo = () => {
  const [showDemo, setShowDemo] = useState(false);

  // Mock the useParams hook for demo
  const mockGroupData = {
    id: '231e6e7e-7fc4-459d-829c-09b03f9119a4',
    name: 'Beth Shalom Community',
    description: 'A vibrant Jewish community in Brooklyn',
    logo_url: 'https://via.placeholder.com/64/2563eb/ffffff?text=BS'
  };

  if (showDemo) {
    // Mock the component with test data
    return (
      <div>
        <div style={{ position: 'fixed', top: 10, right: 10, zIndex: 1000 }}>
          <button 
            onClick={() => setShowDemo(false)}
            style={{ background: '#ef4444', color: 'white', padding: '8px 16px', border: 'none', borderRadius: '4px' }}
          >
            Close Demo
          </button>
        </div>
        <MockGroupClaimPage group={mockGroupData} />
      </div>
    );
  }

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Group Claim Demo</h1>
      <p className="mb-4">This will show you what the group claim page looks like:</p>
      <button 
        onClick={() => setShowDemo(true)}
        className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
      >
        Preview Group Claim UI
      </button>
    </div>
  );
};

// Mock version of GroupClaimPage for demo
const MockGroupClaimPage = ({ group }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [claiming, setClaiming] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    setClaiming(true);
    setError('');
    
    // Simulate API call
    setTimeout(() => {
      alert(`🎉 Demo: You would now own ${group.name}!`);
      setClaiming(false);
    }, 2000);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="bg-white rounded-lg shadow-md p-8">
          {/* Group Header */}
          <div className="text-center mb-8">
            <div className="flex items-center justify-center mb-4">
              {group?.logo_url ? (
                <img 
                  src={group.logo_url} 
                  alt={group.name}
                  className="w-16 h-16 rounded-full object-cover mr-3"
                />
              ) : (
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mr-3">
                  <span className="text-white text-xl font-bold">
                    {group?.name?.charAt(0)?.toUpperCase()}
                  </span>
                </div>
              )}
              <div>
                <h1 className="text-2xl font-bold text-gray-900">
                  Claim {group?.name}
                </h1>
                <p className="text-sm text-gray-600 mt-1">
                  This group is ready for you!
                </p>
              </div>
            </div>
            
            {group?.description && (
              <p className="text-gray-600 text-sm mb-4">{group.description}</p>
            )}
            
            <p className="text-sm text-gray-500">
              Create your account to become the owner of this group
            </p>
          </div>

          {/* Registration Form */}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                Your Name
              </label>
              <input
                id="name"
                name="name"
                type="text"
                required
                value={formData.name}
                onChange={handleInputChange}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter your full name"
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Email Address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                required
                value={formData.email}
                onChange={handleInputChange}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter your email"
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                required
                value={formData.password}
                onChange={handleInputChange}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                placeholder="Create a password (min 6 characters)"
              />
            </div>

            <div>
              <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">
                Confirm Password
              </label>
              <input
                id="confirmPassword"
                name="confirmPassword"
                type="password"
                required
                value={formData.confirmPassword}
                onChange={handleInputChange}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                placeholder="Confirm your password"
              />
            </div>

            {error && (
              <div className="text-red-600 text-sm bg-red-50 p-3 rounded-md">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={claiming}
              className={`w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${claiming ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              {claiming ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  Claiming Group...
                </>
              ) : (
                `Claim ${group?.name} & Create Account`
              )}
            </button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-xs text-gray-500">
              By creating an account, you agree to our terms of service and privacy policy.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupClaimDemo;
